/**
 * Motion-токены в JS — зеркало CSS (`packages/ui/src/styles/tokens.css` §Animation).
 * Нужны там, где длительность уходит в `setTimeout` / Motion, а не только в className.
 *
 * Шкала: instant 100 · fast 140 · base 220 · slow 360. Не плодить другие ms.
 */

export const DUR_INSTANT_MS = 100;
export const DUR_FAST_MS = 140;
export const DUR_BASE_MS = 220;
export const DUR_SLOW_MS = 360;

/** Expand / collapse (`--sh-dur-expand` = `--sh-dur-base`). */
export const DISCLOSE_MS = DUR_BASE_MS;

/** `--sh-ease-out` / easeOutExpo — enter/exit без пружинного overshoot. */
export const EASE_OUT = [0.22, 1, 0.36, 1] as const;
